/* @flow */
import { getterFromKeyPath, get } from 'trustar/utils';
import { createSelector } from 'reselect';
import { alphabetize } from 'trustar/utils';
import { sharingGroupToFormOptions } from './utils';
import { SharingGroup } from './types';
import { pipe } from 'ramda';
import { List } from 'immutable';

export const loading = getterFromKeyPath(['groups', 'loading']);

// get all sharing groups, alphebatized by name
export const sharingGroups = createSelector(
  getterFromKeyPath(['groups', 'sharingGroups']),
  groups => groups.sort(alphabetize)
);

// get sharing group by guid
export const sharingGroup = (guid: string) => createSelector(
  sharingGroups,
  get(guid, List())
);

// determine initial form values for sharing group add/edit form
export const getInitialFormValues = (guid: string) => createSelector(
  sharingGroup(guid),
  pipe(
    group => group || SharingGroup(),
    group => ({
      name: group.get('name'),
      description: group.get('description'),
    })
  )
);

// get companies for group
export const companies = (guid: string) => createSelector(
  sharingGroup(guid),
  pipe(
    group => group || SharingGroup(),
    get('companies', List()),
    companies => companies.sort(alphabetize)
  )
);

// get sharing group options for form
export const sharingGroupFormOptions = createSelector(
  sharingGroups,
  sharingGroups => sharingGroups
    .toList()
    .map(sharingGroupToFormOptions)
    .toJS()
);



// WEBPACK FOOTER //
// ./src/app/modules/groups/getters.js